import { render, staticRenderFns } from "./sx1.vue?vue&type=template&id=667b2de0&"
import script from "./sx1.vue?vue&type=script&lang=js&"
export * from "./sx1.vue?vue&type=script&lang=js&"
import style0 from "./sx1.vue?vue&type=style&index=0&id=667b2de0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports